import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage/index.vue';

import ToolsPage from '@/components/ToolsPage/index.vue';
import LevelZero from '@/components/LevelZero/index.vue';
import LevelOne from '@/components/LevelOne/index.vue';
import LevelTwo from '@/components/LevelTwo/index.vue';
import AdminLogin from '@/components/AdminLogin/index.vue';
import AdminDashboard from '@/components/AdminDashboard/index.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  
  {
    path: '/toolspage',
    name: 'ToolsPage',
    component: ToolsPage,
  },
  {
    path: '/levelZero/:id',
    name: 'LevelZero',
    
    component: LevelZero,
    props: true,
  },
  {
    path: '/levelOne/:id',
    name: 'LevelOne',
    
    component: LevelOne,
    props: true,
  },
  {
    path: '/levelTwo/:id',
    name: 'LevelTwo',
    
    component: LevelTwo,
    props: true,
  },
  {
    path: '/gw-admin',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { hideLayout: true },
  },
  {
    path: '/gw-admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { hideLayout: true, requiresAuth: true },
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = sessionStorage.getItem('admin_token');
    if (!token) {
      return next({ name: 'AdminLogin' });
    }
  }
  next();
});

export default router;
